/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
 

export enum pagingEntityEnum {
  JOURNEY = 'Journey',
  ROUTE = 'Route',
  ROUTE_GROUP = 'RouteGroup',
}
